/* bfc-checkout.js — Best Friend Club: "Continue to payment" on /pages/plan → Shopify's secure checkout.
   Listens for the cancelable `bfc:checkout` event from bfc-plan.js. The subscription service
   (repo packages/server, POST /quote) re-runs the engine, saves the quote and returns the cart lines plus a
   one-use code that brings today's payment to the plan price. We replace any earlier plan lines in the cart,
   add these, and open checkout with the code applied. Nothing is charged until the customer pays there.
   If the service is not set (section setting empty), we do nothing and bfc-plan.js says payment is not connected. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bfc-plan]');
  var service = root && (root.getAttribute('data-service') || '').replace(/\/+$/, '');
  if (!root || !service) return;

  function say(el, html) { if (el) { el.hidden = false; el.innerHTML = html; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.ok === false) { var e = new Error(data.message || 'HTTP ' + res.status); e.userFacing = !!data.message; throw e; }
          return data;
        });
      });
  }

  /* Remove plan lines from an earlier attempt, keep anything else the customer has in the cart */
  function clearOldPlanLines() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (it) { if (it.properties && it.properties._bfc_quote) updates[it.key] = 0; });
      if (!Object.keys(updates).length) return null;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    });
  }

  /* A brand-new exact-price plan (service sellingplans.js) can take a few seconds to reach the storefront after
     Recharge has created it; until then Shopify answers "Cannot apply selling plan to variant". Wait and retry. */
  function addToCart(items, statusEl, attempt) {
    attempt = attempt || 0;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }) }).then(function (res) {
      return res.json().then(function (d) {
        var msg = d.description || d.message || '';
        if (!res.ok && /selling plan/i.test(msg) && attempt < 12) {
          if (statusEl && attempt === 0) say(statusEl, 'Setting up your dog’s plan at checkout, a few more seconds…');
          return new Promise(function (r) { setTimeout(r, 2000); }).then(function () { return addToCart(items, statusEl, attempt + 1); });
        }
        if (!res.ok) { var e = new Error(msg || 'Could not add to the basket'); e.userFacing = true; throw e; }
        return d;
      });
    });
  }

  function attributionAttributes(quote, campaign) {
    var at = (campaign && campaign.attribution) || {};
    var first = at.first || {}, last = at.last || {};
    var out = { 'BFC campaign code': quote.campaignCode || '', 'BFC code source': quote.campaignSource || '', 'BFC quote': quote.quoteId || '' };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'].forEach(function (k) {
      out['First ' + k] = first[k] || ''; out['Last ' + k] = last[k] || '';
    });
    out['First landing page'] = first.landing || ''; out['First referrer'] = first.referrer || '';
    out['Last landing page'] = last.landing || '';
    return out;
  }

  root.addEventListener('bfc:checkout', function (ev) {
    var d = ev.detail || {};
    ev.preventDefault();
    var btn = d.button;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    say(d.statusEl, 'Setting up your secure checkout…');

    var answers = Object.assign({}, d.engineInput || {}, { ageMonths: d.ageMonths, vetDiet: d.vetDiet });
    postJSON(service + '/quote', {
      choice: d.choice === 'trial' ? 'trial' : 'plan',
      answers: answers,
      dogName: d.dogName,
      consentText: d.consentText,
      campaign: d.campaign,
      shownCyclePence: d.shownPence != null ? d.shownPence : (d.plan && d.plan.cycleChargePence)
    }).then(function (quote) {
      return clearOldPlanLines().then(function () { return addToCart(quote.items, d.statusEl); }).then(function () { return quote; });
    }).then(function (quote) {
      /* Revision 2 items 48 + 49: the originating code and the first/last-touch source ride on the order itself
         (Shopify order "Additional details", in every order export), next to the quote id on each line. */
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributionAttributes(quote, d.campaign) }) }).catch(function () {}).then(function () { return quote; });
    }).then(function (quote) {
      var url = '/checkout' + (quote.code ? '?discount=' + encodeURIComponent(quote.code) : '');
      window.location.assign(url);
    }).catch(function (err) {
      console.error('[bfc-checkout]', err);
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      say(d.statusEl, '<strong>We could not open the checkout.</strong> ' +
        (err.userFacing ? esc(err.message) + ' ' : '') + 'Nothing was charged. Please try again in a moment.');
    });
  });
})();
